// The button. For any click action, in four variants: primary (one per
// view), secondary, ghost, and icon (a square ghost for a single glyph).
// tone="bad" makes a destructive primary. Not for navigation: links that
// look like buttons use ButtonLink so the URL semantics stay.

import { Link } from 'react-router-dom'
import './button.css'

function classes(variant, tone, block, className) {
  return [
    'ui-btn',
    `ui-btn-${variant}`,
    tone === 'bad' ? 'ui-btn-bad' : '',
    block ? 'ui-btn-block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')
}

export function Button({
  variant = 'secondary',
  tone,
  block = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  return (
    <button type={type} className={classes(variant, tone, block, className)} {...rest}>
      {children}
    </button>
  )
}

export function ButtonLink({
  variant = 'secondary',
  tone,
  block = false,
  className = '',
  children,
  ...rest
}) {
  return (
    <Link className={classes(variant, tone, block, className)} {...rest}>
      {children}
    </Link>
  )
}
